export default {
  option: {
    marginBottom: '16px',
    listStyle: 'none',
    '@media (min-width: 600px)': {
      display: 'inline-block',
      verticalAlign: 'top',
      width: 'calc(100% / 3 - 22px)',
      marginBottom: '12px',
    },
    '&:not(:nth-of-type(3n + 3))': {
      '@media (min-width: 600px)': {
        marginRight: '30px',
      },
      '&:lang(ar)': {
        '@media (min-width: 600px)': {
          marginRight: 0,
          marginLeft: '30px'
        }
      }
    }
  }
};
